import { Circle } from "@mui/icons-material";
import {
    Box,
    Card,
    Paper,
    styled,
    Tooltip,
    tooltipClasses,
    TooltipProps,
} from "@mui/material";
import { ResponsiveChartContainer } from "@mui/x-charts";

export const S = {
    ChartContainer: styled(ResponsiveChartContainer)(({ theme }) => ({
        "& .MuiLineElement-root": {
            strokeWidth: 2,
        },
        "& .MuiLineElement-series-intensity, & .MuiLineElement-series-projected, & .MuiLineElement-series-diff":
            { stroke: "transparent" },

        "& .MuiLineElement-series-reduction": {
            strokeWidth: 1,
        },

        "& .MuiChartsAxis-tickLabel": {
            fill: theme.palette.text.secondary,
        },

        "& .MuiChartsAxis-directionY": {
            transform: "translate(40px, 0)",
        },
        "& .MuiChartsAxis-directionX": {
            transform: "translate(0, 560px)",
        },

        "& .MuiChartsAxisHighlight-root": {
            stroke: "rgba(55, 55, 55, 0.1)",
            strokeWidth: "3.5%",
            strokeDasharray: "0",
        },

        "& .MuiAreaElement-series-diff": {
            fill: "url(#diagonalHatch)",
        },
    })),

    Tooltip: styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            padding: theme.spacing(4),
            backgroundColor: theme.palette.common.white,
            boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.10)",
        },
    })),

    TooltipTitle: styled(Box)(({ theme }) => ({
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        fontSize: 14,
    })),

    TooltipCircle: styled(Circle)(({ theme }) => ({
        marginRight: theme.spacing(1),
        fontSize: 10,
        display: "inline",
    })),

    Card: styled(Card)(({ theme }) => ({
        flex: 1,
        color: "white",
        justifyContent: "space-between",
        padding: theme.spacing(4),
        maxHeight: theme.spacing(120),
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        flexDirection: "column",
    })),

    TooltipPaper: styled(Paper)(({ theme }) => ({
        padding: theme.spacing(4),
        boxShadow: `0px 0px 20px 0px #0000001A`,
    })),
    TooltipItem: styled(Box)(({ theme }) => ({
        display: "flex",
        fontSize: 14,
        gap: theme.spacing(4),
        justifyContent: "space-between",
        alignItems: "center",
    })),

    LegendTooltip: styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.common.white,
            padding: theme.spacing(4),
            fontSize: theme.typography.pxToRem(12),
            boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.10)",
        },
    })),
};
